<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Áreas</h5>
        </div>
        <emt-form ref="area-form" v-bind:resource="config.api + '/area/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="area-grid" v-bind:resource="config.api + '/area_full_data/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-area',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre área',
                    'placeholder': 'Ingrese nombre de área',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'responsible',
                    'label': 'Responsable',
                    'placeholder': 'Seleccione responsable',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'boss',
                    'label': 'Jefe',
                    'placeholder': 'Seleccione jefe',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Nombre área',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': {
                        'object': 'unit',
                        'key': 'name'
                    },
                    'label': 'Unidad',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': {
                        'object': 'responsible',
                        'key': 'username'
                    },
                    'label': 'Responsable',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': {
                        'object': 'boss',
                        'key': 'username'
                    },
                    'label': 'Jefe',
                    'value': null,
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': null,
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/area/',
            deleteUrl: Config.api + '/area/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['area-grid'].reload()
        },
        /*
        *esta funcion permite consultar y listar las unidades
        */
        getUnits: function () {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los usuarios del aplicativo
        */
        getResponsible: function () {
            var self = this
            self.$http.get(Config.api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[2].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los usuarios del aplicativo
        */
        getBoss: function () {
            var self = this
            self.$http.get(Config.api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[3].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getUnits()
        this.getResponsible()
        this.getBoss()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-area.vue?79ae051e